<div class="rendelo-list-page">
    <mat-card>
        <mat-card-header>
            <mat-card-title>Páciensek listája</mat-card-title>
            <div class="spacer"></div>
            <div class="action-buttons">
                <button mat-raised-button
                        color="primary"
                        (click)="addPaciens()">
                    <mat-icon>add</mat-icon> Új páciens
                </button>
                @if (selectedPaciens) {
                    <mat-divider [vertical]="true"></mat-divider>
                    <button mat-raised-button
                            class="btn-details"
                            (click)="viewDetails()">
                        <mat-icon>visibility</mat-icon> Részletek
                    </button>
                    <button mat-raised-button
                            class="btn-edit"
                            (click)="editPaciens()">
                        <mat-icon>edit</mat-icon> Módosítás
                    </button>
                    <button mat-raised-button
                            class="btn-delete"
                            color="warn"
                            (click)="deletePaciens()">
                        <mat-icon>delete</mat-icon> Törlés
                    </button>
                }
            </div>
        </mat-card-header>
        <mat-card-content>
            <div class="search-container">
                <mat-form-field appearance="outline">
                    <mat-label>Keresés</mat-label>
                    <input matInput
                           [value]="searchQuery()"
                           (input)="applyFilter($event)"
                           placeholder="Név, TAJ, telefon, email, cím..."
                           autofocus
                           #input>
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
            </div>

            <div class="data-placeholder">
                <ag-grid-angular class="ag-theme-alpine"
                                 style="width: auto; height: 100%;"
                                 [columnDefs]="colDefs"
                                 [rowModelType]="'infinite'"
                                 [pagination]="true"
                                 [paginationAutoPageSize]="true"
                                 [cacheBlockSize]="pageSize"
                                 [rowSelection]="rowSelectionConfig"
                                 (gridReady)="onGridReady($event)"
                                 (selectionChanged)="onSelectionChanged($event)">
                </ag-grid-angular>
            </div>
        </mat-card-content>
    </mat-card>
</div>